import React, { useEffect, useState } from 'react';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 25,
    s: 12
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <section className="py-12 bg-surface border-t border-white/5 relative overflow-hidden" aria-label="Llamada final a la acción" data-id="element-58">
      <div className="container mx-auto px-4 max-w-5xl relative z-10 text-center" data-id="element-59">
        <FadeIn data-id="element-60">
          <div className="text-center mb-10" data-id="element-61">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-62">
              ⏰ EL PRECIO DE LANZAMIENTO CIERRA EN:
            </h2>
            <div className="flex items-center justify-center gap-2 md:gap-4 text-3xl md:text-5xl font-heading font-bold text-gold mb-8" data-id="element-63">
              <div className="bg-surfaceLight border border-white/10 rounded-xl px-4 py-3 min-w-[80px]" data-id="element-64">
                {formatTime(timeLeft.h)}
                <span className="text-sm block text-gray-400 font-body font-normal mt-1" data-id="element-65">
                  hs
                </span>
              </div>
              <span className="text-gray-500 pb-6" data-id="element-66">:</span>
              <div className="bg-surfaceLight border border-white/10 rounded-xl px-4 py-3 min-w-[80px]" data-id="element-67">
                {formatTime(timeLeft.m)}
                <span className="text-sm block text-gray-400 font-body font-normal mt-1" data-id="element-68">
                  min
                </span>
              </div>
              <span className="text-gray-500 pb-6" data-id="element-69">:</span>
              <div className="bg-surfaceLight border border-white/10 rounded-xl px-4 py-3 min-w-[80px]" data-id="element-70">
                {formatTime(timeLeft.s)}
                <span className="text-sm block text-gray-400 font-body font-normal mt-1" data-id="element-71">
                  seg
                </span>
              </div>
            </div>
          </div>
        </FadeIn>

        <div className="flex flex-col md:flex-row justify-center gap-6 mb-12" data-id="element-72">
          <FadeIn delay={0.1} className="flex-1 max-w-md mx-auto md:mx-0 w-full" data-id="element-73">
            <a href="#" className="flex flex-col items-center justify-center p-8 bg-surfaceLight border border-white/10 rounded-2xl hover:border-white/30 transition-colors h-full focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" aria-label="Comprar Sistema Maestro de Aluminio por $19.990 ARS" data-id="element-74">
              <span className="text-lg font-bold text-white mb-2" data-id="element-75">
                📘 SISTEMA MAESTRO DE ALUMINIO
              </span>
              <span className="text-sm text-gray-400 mb-6 text-center" data-id="element-76">
                6 Tomos + 4 Bonos · Todas las tipologías
              </span>
              <div className="flex items-center gap-3 mb-6" data-id="element-77">
                <span className="text-gray-500 line-through text-lg" data-id="element-78">
                  $45.000
                </span>
                <span className="text-3xl font-bold text-white" data-id="element-79">
                  $19.990 ARS
                </span>
              </div>
              <div className="w-full py-3 px-6 rounded-xl font-bold text-white border border-white/20 hover:bg-white/5 transition-colors uppercase tracking-wider text-sm" data-id="element-80">
                🔧 Quiero mi Sistema Maestro
              </div>
            </a>
          </FadeIn>

          <FadeIn delay={0.2} className="flex-1 max-w-md mx-auto md:mx-0 w-full" data-id="element-81">
            <a href="#" className="flex flex-col items-center justify-center p-8 bg-gold rounded-2xl hover:bg-gold/90 transition-colors shadow-lg h-full relative focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" aria-label="Comprar Sistema Maestro + Fichas de Taller por $29.990 ARS" data-id="element-82">
              <span className="text-lg font-bold text-background mb-2" data-id="element-83">
                🏆 SISTEMA MAESTRO + FICHAS DE TALLER ⭐
              </span>
              <span className="text-sm text-background/80 font-medium mb-6 text-center" data-id="element-84">
                6 Tomos + 4 Bonos + Sistema de Trabajo en 1 Minuto
              </span>
              <div className="flex items-center gap-3 mb-6" data-id="element-85">
                <span className="text-background/50 line-through text-lg" data-id="element-86">
                  $55.000
                </span>
                <span className="text-3xl font-bold text-background" data-id="element-87">
                  $29.990 ARS
                </span>
              </div>
              <div className="w-full py-3 px-6 rounded-xl font-bold text-gold bg-background hover:bg-background/90 transition-colors uppercase tracking-wider text-sm" data-id="element-88">
                → QUIERO EL PACK COMPLETO CON FICHAS
              </div>
            </a>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-89">
          <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-gray-400" data-id="element-90">
            <div className="flex items-center gap-2" data-id="element-91">
              <span className="text-gold" data-id="element-92">🔒</span>
              <span data-id="element-93">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-94">
              <span className="text-gold" data-id="element-95">⚡</span>
              <span data-id="element-96">Acceso en 5 minutos</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-97">
              <span className="text-gold" data-id="element-98">🛡️</span>
              <span data-id="element-99">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-100">
              <span className="text-gold" data-id="element-101">💳</span>
              <span data-id="element-102">Mercado Pago | Tarjeta | Transferencia</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}